import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Util from "@/js/common/Util";
import React from "react";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";
import MemberFile from "../FileBox/MemberFile";
import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";

interface Props {
    mbrasAtrzDocId: string;
    mbrasId: string;
    setModalOpen: Function;
    setCallTime: Function;
}

const MbrasNewMngDialog = ({ mbrasAtrzDocId, mbrasId, setModalOpen, setCallTime }: Props) => {
    const [mbrasNm, setMbrasNm] = React.useState<string>(""); // 성명
    const [telno, setTelno] = React.useState<string>(""); // 휴대전화번호
    const [brdtDate, setBrdtDate] = React.useState<string>(""); // 생년월일
    const [gndrCd, setGndrCd] = React.useState<string>(""); // 성별
    const [upOgnzCd, setUpOgnzCd] = React.useState<string>(""); // 소속본부
    const [lbrShpSeCd, setLbrShpSeCd] = React.useState<string>(""); // 근로형태
    const [wtjrNm, setWtjrNm] = React.useState<string>(""); // 관내
    const [ogdpOrgCd, setOgdpOrgCd] = React.useState<string>(""); // 소속지부
    const [atrzSttsCd, setAtrzSttsCd] = React.useState<string>("01"); // 상태 / 기본값 (작성중)
    const [ocptTypeCd, setOcptTypeCd] = React.useState<string>(""); // 직종
    const [frstJncmpYmd, setFrstJncmpYmd] = React.useState<string>(""); // 입직년월일
    const [joinYmd, setJoinYmd] = React.useState<string>(""); // 가입신청일
    const [addr, setAddr] = React.useState<string>(""); // 주소
    const [memo, setMemo] = React.useState<string>(""); // 메모
    const [atrzOpnnCn, setAtrzOpnnCn] = React.useState<string>(""); // 반려 사유
    const [listLine, setListLine] = React.useState<any[]>([]);  // 결재 라인 정보
    const [openLine, setOpenLine] = React.useState<boolean>(false); // 기본 펼침/접힘

    const [joinApfrFile, setJoinApfrFile] = React.useState<File>(); // 가입신청서 파일
    const [wthdFile, setWthdFile] = React.useState<File>(); // 원천징수 파일
    const [etcFile, setEtcFile] = React.useState<File>(); // 기타 첨부파일
    const [joinApfrFileNm, setJoinApfrFileNm] = React.useState<string>(""); // 가입신청서 파일명
    const [wthdFileNm, setWthdFileNm] = React.useState<string>(""); // 원천징수 파일명
    const [etcFileNm, setEtcFileNm] = React.useState<string>(""); // 기타 첨부파일명
    const [joinmbrasAtchFileId, setJoinMbrasAtchFileId] = React.useState<string>(""); // 가입신청서 파일 ID
    const [wthdmbrasAtchFileId, setWthdMbrasAtchFileId] = React.useState<string>(""); // 원천징수 파일 ID
    const [etcmbrasAtchFileId, setEtcMbrasAtchFileId] = React.useState<string>(""); // 기타 첨부파일 ID
    const [openJoinExample, setOpenJoinExample] = React.useState<boolean>(false); // 신청서 예시 모달

    const userInfo = useRecoilValue(Atom.userInfo);

    React.useEffect(() => {
        // NEW일 때만 자동 세팅 (MOD는 조회값 그대로)
        if (!Util.isEmpty(mbrasAtrzDocId)) return;

        if (userInfo.ognzCd !== "00_000") {
            setUpOgnzCd(userInfo.upOgnzCd);
        } // 본부 자동 세팅

        if (!userInfo.ognzCd.includes("000")) {
            setOgdpOrgCd(userInfo.ognzCd); // 지부 자동 세팅
        }
    }, [mbrasAtrzDocId, userInfo]);

    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return; // NEW면 상세조회 안함

        AppContext.showSpinner();

        Axios.dataAccess({
            url: "system/mbras/new/select-mbras-new-dtl.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                mbrasAtrzDocId: mbrasAtrzDocId,
            },
            onSuccessFn: (res: any) => {
                if (Util.isNotEmpty(res.result.item)) {
                    const item = res.result.item;

                    setMbrasNm       (item.mbrasNm      ); // 성명
                    setTelno         (item.telno        ); // 휴대전화번호
                    setBrdtDate      (item.brdtDate     ); // 생년월일
                    setGndrCd        (item.gndrCd       ); // 성별
                    setUpOgnzCd      (item.upOgnzCd     ); // 소속본부
                    setOgdpOrgCd     (item.ogdpOrgCd    ); // 소속지부
                    setWtjrNm        (item.wtjrNm       ); // 관내
                    setLbrShpSeCd    (item.lbrShpSeCd   ); // 근로형태
                    setOcptTypeCd    (item.ocptTypeCd   ); // 직종
                    setAtrzSttsCd    (item.atrzSttsCd   ); // 결재상태
                    setFrstJncmpYmd  (item.frstJncmpYmd ); // 입직년월일
                    setJoinYmd       (item.joinYmd      ); // 가입신청일
                    setAddr          (item.addr         ); // 주소
                    setMemo          (item.memo         ); // 메모
                    setAtrzOpnnCn    (item.atrzOpnnCn   ); // 반려사유
                    setListLine      (res.result.listLine); // 결재 라인
                }

                if (Util.isNotEmpty(res.result.listFile)) {
                    const listFile = res.result.listFile;
                    const joinFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "01");
                    const wthdFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "02");
                    const etcFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "03");

                    if (Util.isNotEmpty(joinFileInfo)) {
                        setJoinMbrasAtchFileId(joinFileInfo.mbrasAtchFileId);
                        setJoinApfrFileNm     (joinFileInfo.fileNm);
                    }

                    if (Util.isNotEmpty(wthdFileInfo)) {
                        setWthdMbrasAtchFileId(wthdFileInfo.mbrasAtchFileId);
                        setWthdFileNm          (wthdFileInfo.fileNm);
                    }

                    if (Util.isNotEmpty(etcFileInfo)) {
                        setEtcMbrasAtchFileId(etcFileInfo.mbrasAtchFileId);
                        setEtcFileNm          (etcFileInfo.fileNm);
                    }
                }

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId]);

    function handleDelete() {
        // NEW(등록) 화면이면 삭제 불가
        if (Util.isEmpty(mbrasAtrzDocId)) {
            AppContext.openAlert({ title: "삭제 불가", msg: "삭제할 대상이 없습니다.", icon: "warning" });
            return;
        }

        AppContext.openAlert({
            title: "삭제",
            msg: "정말 삭제하시겠습니까?",
            confirmText: "삭제하기",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url: "system/mbras/new/delete-mbras-info.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        mbrasAtrzDocId: mbrasAtrzDocId,
                    },
                    onSuccessFn: (res: any) => {
                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "삭제 완료",
                            msg: "삭제가 완료되었습니다.",
                            icon: "success",
                        });

                        // 목록 재조회 트리거
                        if (typeof setCallTime === "function") setCallTime(Date.now());

                        // 모달 닫기
                        if (typeof setModalOpen === "function") setModalOpen(false);
                    },
                });
            },
        });
    }

    function saveMbrasNew() {
        AppContext.showSpinner();

        Axios.dataAccess({
            url: "system/mbras/new/save-mbras-new.do",
            methodType: "post",
            isMultipart: true,
            paramData: {
                mbrasAtrzDocId: mbrasAtrzDocId, // 조합원 결재 문서 ID
                mbrasId: mbrasId, // 조합원 ID
                mbrasNm: mbrasNm, // 조합원명
                brdtDate: brdtDate, // 생년월일
                gndrCd: gndrCd, // 성별코드
                telno: telno, // 전화번호
                lbrShpSeCd: lbrShpSeCd, // 근로형태구분코드
                ocptTypeCd: ocptTypeCd, // 직종유형코드
                ogdpOrgCd: ogdpOrgCd, // 소속조직코드
                wtjrNm: wtjrNm, // 관내명
                addr: addr, // 주소
                memo: memo, // 메모
                frstJncmpYmd: frstJncmpYmd, // 최초입사일자
                joinYmd: joinYmd, // 가입일자
                applyDt: joinYmd, // 신청일자
                mbrasJoinSttsCd: "00", // 조합가입상태코드 (00: 미가입)
                atrzSttsCd: "02", // 결재상태코드 (02: 작성완료)
                joinApfrFile: joinApfrFile, // 신청서 파일
                wthdFile: wthdFile, // 원천징수 파일
                etcFile: etcFile, // 기타 첨부파일
                callType: "MEMBER", // 첨부파일 구분(저장경로)
                wthdSeCd: "01", // 조합원 원천징수 구분(신규: 01)
            },

            onSuccessFn: (res: any) => {
                AppContext.hideSpinner();

                AppContext.openAlert({
                    title: "저장 완료",
                    msg: "작성완료 처리되었습니다.",
                    icon: "success",
                });

                // 목록 재조회 트리거
                if (typeof setCallTime === "function") setCallTime(Date.now());

                // 모달 닫기
                if (typeof setModalOpen === "function") setModalOpen(false);
            },
        });
    }

    function checkMbrasNewDuplicate() {
        Axios.dataAccess({
            url: "system/mbras/new/select-mbras-new-dup-chk.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                mbrasNm: mbrasNm,
                telno: telno,
            },
            onSuccessFn: (res: any) => {
                const item = res.result.item;
                const activeDupCnt = Number(item?.activeDupCnt || 0);
                const whdwlSameNmCnt = Number(item?.whdwlSameNmCnt || 0);

                // 현재 조합원 중복
                if (activeDupCnt > 0) {
                    AppContext.openAlert({
                        title: "조합원 중복 등록 확인",
                        msg: "동일한 성명과 전화번호로 등록된 조합원이 있습니다.\n그래도 작성하시겠습니까?",
                        icon: "warning",
                        confirmText: "그래도 작성",
                        handleConfirm: () => {
                            saveMbrasNew();
                        },
                    });
                }

                // 현재 조합원 중복이 없는 경우에만 탈퇴 조합원 확인
                else if (whdwlSameNmCnt > 0) {
                    AppContext.openAlert({
                        title: "조합원 탈퇴 후 재가입 확인",
                        msg: "탈퇴 조합원 중 동일한 성명의 조합원이 있습니다.\n재가입 대상인지 확인해 주세요.\n그래도 작성하시겠습니까?",
                        icon: "warning",
                        confirmText: "그래도 작성",
                        handleConfirm: () => {
                            saveMbrasNew();
                        },
                    });
                }

                // 현재 조합원 중복도 없고 탈퇴 조합원도 없는 경우
                else {
                    AppContext.openAlert({
                        title: "작성완료",
                        msg: "작성완료 처리하시겠습니까?",
                        confirmText: "작성완료",
                        handleConfirm: () => {
                            saveMbrasNew();
                        },
                    });
                }
            },
        });
    }

    function handleSave() {
        // =========================
        // 유효성 검사 (기존 그대로)
        // =========================
        if (Util.isEmpty(mbrasNm)) {
            AppContext.openAlert({ title: "성명 확인", msg: "성명을 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(telno)) {
            AppContext.openAlert({ title: "전화번호 확인", msg: "전화번호를 입력해주세요.", icon: "warning" });
            return;
        }
        if (!Util.chkPhonePtn(telno)) {
            AppContext.openAlert({ title: "전화번호 확인", msg: "전화번호를 올바르게 입력해주세요", icon: "warning" });
            return;
        }
        if (Util.isEmpty(brdtDate)) {
            AppContext.openAlert({ title: "생년월일 확인", msg: "생년월일을 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(gndrCd)) {
            AppContext.openAlert({ title: "성별 확인", msg: "성별을 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(upOgnzCd)) {
            AppContext.openAlert({ title: "소속본부 확인", msg: "소속본부를 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(ogdpOrgCd)) {
            AppContext.openAlert({ title: "소속지부 확인", msg: "소속지부를 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(lbrShpSeCd)) {
            AppContext.openAlert({ title: "근로형태 확인", msg: "근로형태를 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(ocptTypeCd)) {
            AppContext.openAlert({ title: "직종 확인", msg: "직종을 입력해주세요.", icon: "warning" });
            return;
        }
        // if (Util.isEmpty(wtjrNm)) {
        //     AppContext.openAlert({ title: "관내 확인", msg: "관내를 입력해주세요.", icon: "warning" });
        //     return;
        // }
        if (lbrShpSeCd === "01" && Util.isEmpty(frstJncmpYmd)) {
            AppContext.openAlert({ title: "입직년월일 확인", msg: "입직년월일을 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(joinYmd)) {
            AppContext.openAlert({ title: "가입신청일 확인", msg: "가입신청일을 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isNotEmpty(joinYmd) && Util.unHypen(joinYmd) > Util.dateToString(new Date(), "YYYYMMDD")) {
            AppContext.openAlert({ title: "가입신청일 확인", msg: "오늘 이후의 날짜는 입력할 수 없습니다.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(addr)) {
            AppContext.openAlert({ title: "주소 확인", msg: "주소를 입력해주세요.", icon: "warning" });
            return;
        }
        if (!joinApfrFile && Util.isEmpty(joinmbrasAtchFileId)) {
            AppContext.openAlert({
                title: "첨부파일 확인",
                msg: "가입 신청서를 첨부해주세요.",
                icon: "warning",
            });
            return;
        }

        if (!wthdFile && Util.isEmpty(wthdmbrasAtchFileId)) {
            AppContext.openAlert({
                title: "첨부파일 확인",
                msg: "원천징수 동의서를 첨부해주세요.",
                icon: "warning",
            });
            return;
        }
        checkMbrasNewDuplicate();
    }

    // 근로형태 값에 따라 사용할 "직종 공통코드 그룹" 결정
    const ocptGroupCd =
        lbrShpSeCd === "01"
            ? "PMEMP_OCPT_TYPE_CD"
            : lbrShpSeCd === "02"
                ? "IREMP_OCPT_TYPE_CD"
                : "";


    function handleTempSave() {
        if (Util.isEmpty(mbrasNm)) {
            AppContext.openAlert({ title: "성명 확인", msg: "성명은 필수 입력 사항입니다", icon: "warning" });
            return;
        }
        if (Util.isEmpty(upOgnzCd)) {
            AppContext.openAlert({ title: "소속본부 확인", msg: "소속본부를 입력해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(ogdpOrgCd)) {
            AppContext.openAlert({ title: "소속지부 확인", msg: "소속지부를 입력해주세요.", icon: "warning" });
            return;
        }

        AppContext.openAlert({
            title: "임시저장",
            msg: "임시 저장하시겠습니까?",
            confirmText: "저장하기",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url: "system/mbras/new/save-mbras-new.do",
                    methodType: "post",
                    isMultipart: true,
                    paramData: {
                        mbrasAtrzDocId: mbrasAtrzDocId, // 조합원 결재 문서 ID
                        mbrasId: mbrasId, // 조합원 ID
                        mbrasNm: mbrasNm, // 조합원명
                        brdtDate: brdtDate, // 생년월일
                        gndrCd: gndrCd, // 성별코드
                        telno: telno, // 전화번호
                        lbrShpSeCd: lbrShpSeCd, // 근로형태구분코드
                        ocptTypeCd: ocptTypeCd, // 직종유형코드
                        ogdpOrgCd: ogdpOrgCd, // 소속조직코드
                        wtjrNm: wtjrNm, // 관내명
                        addr: addr, // 주소
                        memo: memo, // 메모
                        frstJncmpYmd: frstJncmpYmd, // 최초입사일자
                        joinYmd: joinYmd, // 가입일자
                        applyDt: joinYmd, // 신청일자
                        mbrasJoinSttsCd: "00", // 조합가입상태코드 (00: 미가입)
                        atrzSttsCd: "01", // 결재상태코드 (01: 작성중)
                        joinApfrFile: joinApfrFile, // 신청서 파일
                        wthdFile: wthdFile, // 원천징수 파일
                        etcFile: etcFile, // 기타 첨부파일
                        callType: "MEMBER", // 첨부파일 구분(저장경로)
                        wthdSeCd: "01", // 조합원 원천징수 구분(신규: 01)
                    },

                    onSuccessFn: (res: any) => {
                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "저장 완료",
                            msg: "임시저장 처리되었습니다.",
                            icon: "success",
                        });

                        // 목록 재조회 트리거
                        if (typeof setCallTime === "function") setCallTime(Date.now());

                        // 모달 닫기
                        if (typeof setModalOpen === "function") setModalOpen(false);
                    },
                });
            },
        });
    }

    return (
        <div className="w100p dpFlx">
            <div className="w630">
                <div className="pr10 pl10">
                {atrzSttsCd === "05" && (
                    <AtrzLineBox
                        listLine={listLine}
                        open={openLine}
                        onToggle={() => setOpenLine((v) => !v)}
                        showOrgInfo = {true}
                    />
                )}
                </div>

                {/* =========================
                        기본 정보 입력 영역
                    ========================= */}
                <div className="w630 m0auto">
                    {/* 1행 */}
                    <div className="dpFlx flxNowrap gap20 jcC pt10">
                        {/* 성명 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">
                                성명 <span className="fcE60000">*</span>
                            </div>
                            <div className="w200">
                                <TextBox
                                    value={mbrasNm}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                    placeholder="성명을 입력하세요."
                                    onChangeFunc={(text: string) => setMbrasNm(text)}
                                />
                            </div>
                        </div>

                        {/* 전화번호 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">전화번호</div>
                            <div className="w200">
                                <TextBox
                                    value={Util.setPhoneNum(telno)}
                                    type="phone"
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                    placeholder="휴대전화번호를 입력하세요."
                                    iconEl={
                                        <img
                                            onClick={() => setTelno("")}
                                            className={"csP " + (Util.isEmpty(telno) ? "dpNone" : "")}
                                            src={Util.getImgSrc("common/icon_cancel_fill_18.png")}
                                            alt="icon_cancel_fill_18"
                                        />
                                    }
                                    onChangeFunc={(text: string) => setTelno(Util.unHypen(text))}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 2행 */}
                    <div className="dpFlx flxNowrap gap20 mt10 jcC">
                        {/* 생년월일 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">생년월일</div>
                            <div className="w200">
                                <DatePickerBox
                                    value={brdtDate}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    bgColor="white" textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    onChange={(data: string) => setBrdtDate(data)}
                                />
                            </div>
                        </div>

                        {/* 성별 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">성별</div>
                            <div className="w200">
                                <SelectBox
                                    value={gndrCd}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getCodeArray("GNDR_CD")}
                                    placeholder="성별을 선택하세요"
                                    paddingRight={8}
                                    onChangeFunc={(data: string) => setGndrCd(data)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 3행 */}
                    <div className="dpFlx flxNowrap gap20 mt10 jcC">
                        {/* 소속본부 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">
                                소속본부 <span className="fcE60000">*</span>
                            </div>
                            <div className="w200">
                                <SelectBox
                                    value={upOgnzCd}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    background={userInfo.ognzCd === "00_000" ? "#FFF" : "#f6f6f6"}
                                    codeArray={Util.getUpOrgCodeArray("01").slice(1)}
                                    placeholder="본부 선택"
                                    paddingRight={8}
                                    disabled={userInfo.ognzCd === "00_000" ? false : true}
                                    onChangeFunc={(data: string) => {
                                        setUpOgnzCd(data);
                                        setOgdpOrgCd(""); // 지부 초기화
                                    }}
                                />
                            </div>
                        </div>

                        {/* 근로형태 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">근로형태</div>
                            <div className="w200">
                                <SelectBox
                                    value={lbrShpSeCd}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getCodeArray("LBR_SHP_SE_CD")}
                                    placeholder="근로형태 선택"
                                    paddingRight={8}
                                    onChangeFunc={(data: string) => {
                                        if (data !== lbrShpSeCd) { setOcptTypeCd("");
                                            if (data === "02") { setFrstJncmpYmd("");}
                                        }
                                        setLbrShpSeCd(data);
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 4행 */}
                    <div className="dpFlx flxNowrap gap20 mt10 jcC">
                        {/* 소속지부 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">
                                소속지부 <span className="fcE60000">*</span>
                            </div>
                            <div className="w200">
                                <SelectBox
                                    value={ogdpOrgCd}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    background={userInfo.ognzCd.includes("000") ? "#FFF" : "#f6f6f6"}
                                    codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                                    placeholder="지부 선택"
                                    paddingRight={8}
                                    disabled={userInfo.ognzCd.includes("000") ? false : true}
                                    onChangeFunc={(data: string) => setOgdpOrgCd(data)}
                                />
                            </div>
                        </div>

                        {/* 직종 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">직종</div>
                            <div className="w200">
                                <SelectBox
                                    value={ocptTypeCd}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    background="#fff"
                                    codeArray={ocptGroupCd ? Util.getCodeArray(ocptGroupCd) : []}
                                    placeholder={Util.isEmpty(lbrShpSeCd) ? "근로형태를 먼저 선택" : "직종 선택"}
                                    paddingRight={8}
                                    disabled={Util.isEmpty(lbrShpSeCd) || Util.isEmpty(ocptGroupCd)}
                                    onChangeFunc={(data: string) => setOcptTypeCd(data)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 5행 */}
                    <div className="dpFlx flxNowrap gap20 mt10 jcC">
                        {/* 관내 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">관내</div>
                            <div className="w200">
                                <TextBox
                                    value={wtjrNm}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                    placeholder="관내를 입력하세요."
                                    onChangeFunc={(text: string) => setWtjrNm(text)}
                                />
                            </div>
                        </div>

                        {/* 상태 */}
                        <div className="w280 dpFlx aiC">
                            <div className="w80 fm-b fs13 ls06 fc111111">상태</div>
                            <div className="w200">
                                <SelectBox
                                    value={atrzSttsCd}
                                    width={200} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    background="#f6f6f6"
                                    codeArray={Util.getCodeArray("ATRZ_STTS_CD")}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                    onChangeFunc={(data: string) => setAtrzSttsCd(data)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* 6행 */}
                    <div className="dpFlx flxNowrap gap20 mt10 jcC">
                        {/* 입직년월일 - 정규직만 표시 */}
                        {lbrShpSeCd === "01" ? (
                            <>
                                <div className="w280 dpFlx aiC">
                                    <div className="w80">
                                        <div className="fm-b fs13 ls06 fc111111">
                                            입직년월일
                                        </div>
                                        <div className="fm-c fs10 fc4A90A4 mt2">
                                            정규직 임용일자
                                        </div>
                                    </div>
                                    <div className="w200">
                                        <DatePickerBox
                                            value={frstJncmpYmd}
                                            width={200} height={36}
                                            fontSize={14} fontFamily="fm-c" color="#333"
                                            letterSpacing={-1}
                                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                            bgColor="white" textAlign="left"
                                            calendarThemeColor={AppContext.themeColor}
                                            onChange={(data: string) => setFrstJncmpYmd(data)}
                                        />
                                    </div>
                                </div>

                                {/* 가입신청일 */}
                                <div className="w280 dpFlx aiC">
                                    <div className="w80 fm-b fs13 ls06 fc111111">가입신청일</div>
                                    <div className="w200">
                                        <DatePickerBox
                                            value={joinYmd}
                                            width={200} height={36}
                                            fontSize={14} fontFamily="fm-c" color="#333"
                                            letterSpacing={-1}
                                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                            bgColor="white" textAlign="left"
                                            calendarThemeColor={AppContext.themeColor}
                                            onChange={(data: string) => setJoinYmd(data)}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* 가입신청일 */}
                                <div className="w280 dpFlx aiC">
                                    <div className="w80 fm-b fs13 ls06 fc111111">가입신청일</div>
                                    <div className="w200">
                                        <DatePickerBox
                                            value={joinYmd}
                                            width={200} height={36}
                                            fontSize={14} fontFamily="fm-c" color="#333"
                                            letterSpacing={-1}
                                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                            bgColor="white" textAlign="left"
                                            calendarThemeColor={AppContext.themeColor}
                                            onChange={(data: string) => setJoinYmd(data)}
                                        />
                                    </div>
                                </div>

                                <div className="w280"></div>
                            </>
                        )}
                    </div>

                    {/* 주소 */}
                    <div className="w580 m0auto dpFlx aiC mt10">
                        <div className="w80 fm-b fs13 ls06 fc111111">
                            주소
                        </div>
                        <div className="w500">
                            <TextBox value={addr}
                                width={500} height={36}
                                fontSize={14} fontFamily="fm-c" color="#333"
                                letterSpacing={-1} borderColor="#ddd"
                                borderOnColor="#222" borderRadius={5}
                                style={{ backgroundColor: "#fff", padding: "0 10px", }}
                                placeholder="주소를 입력하세요."
                                onChangeFunc={(text: string) => setAddr(text)}
                            />
                        </div>
                    </div>

                    {/* 메모 */}
                    <div className="w580 m0auto dpFlx mt10">
                        <div className="w80 fm-b fs13 ls06 fc111111 pt8">
                            메모
                        </div>
                        <div className="w500">
                            <textarea
                                value={memo}
                                className="w500 h46 p10 bdrd5 bd1 bdcDDDDDD fm-c fs14 fc333333 bsBdb"
                                style={{
                                    resize: "none",
                                    backgroundColor: "#fff",
                                }}
                                placeholder="조합원 관련 메모를 입력하세요"
                                onChange={(text) => setMemo(text.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* =========================
                        반려 사유 (05: 반려일 때만)
                    ========================= */}
                {atrzSttsCd === "05" && (
                    <div className="w610 m0auto">
                        <div className="dpFlx mt10">
                            <div className="w80 fm-b fs13 ls06 fc111111 pt8">
                                반려 사유
                            </div>
                            <div className="w520">
                                <textarea
                                    value={atrzOpnnCn}
                                    className="w520 h46 p10 bdrd5 bd1 bdcDDDDDD fm-c fs14 fc333333 bsBdb"
                                    style={{
                                        resize: "none",
                                        backgroundColor: "#f6f6f6",
                                    }}
                                    maxLength={2000}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* =========================
                        첨부파일 섹션 (폭 동일 w540)
                    ========================= */}
                <div className="mt20 p14 bd1 bdcDDDDDD bdrd10 w610 bgcFAFAFA bsBdb m0auto">
                    <div className="dpFlx aiC jcSb">
                        <div className="fm-c fs14 fc111111">첨부파일</div>

                        <div className="dpFlx aiC">
                            <span className="fm-c fs12 fc4A90A4 mr10">
                                    신청서 2장을 모두 촬영하여 한 개의 이미지 파일로 업로드
                            </span>

                            <span className="dpInBlock fm-c fs12 fc007bff csP p4 pr10 pl10 bd1 bdcCED4DA bdrd20 bgcF1F8FF"
                                onClick={() => setOpenJoinExample(true)}>예시보기
                            </span>
                        </div>
                    </div>

                    {/* 가입 신청서 */}
                    <div className="mb6">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">가입 신청서</span>
                            <span className="fm-c fs11 fcE60000 ml4">(필수)</span>
                        </div>
                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={joinmbrasAtchFileId}
                                setMbrasAtchFileId={setJoinMbrasAtchFileId}
                                mbrFile={joinApfrFile}
                                setMbrFile={setJoinApfrFile}
                                mbrFileNm={joinApfrFileNm}
                                setMbrFileNm={setJoinApfrFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                                width={580}
                            />
                        </div>
                    </div>

                    {/* 원천징수 동의서 */}
                    <div className="mb6">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">원천징수 동의서</span>
                            <span className="fm-c fs11 fcE60000 ml4">(필수)</span>
                        </div>
                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={wthdmbrasAtchFileId}
                                setMbrasAtchFileId={setWthdMbrasAtchFileId}
                                mbrFile={wthdFile}
                                setMbrFile={setWthdFile}
                                mbrFileNm={wthdFileNm}
                                setMbrFileNm={setWthdFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                                width={580}
                            />
                        </div>
                    </div>

                    {/* 기타 첨부파일 */}
                    <div>
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">기타 첨부파일</span>
                            <span className="fm-c fs11 fc007bff ml4">(필수 아님)</span>
                        </div>
                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcmbrasAtchFileId}
                                setMbrasAtchFileId={setEtcMbrasAtchFileId}
                                mbrFile={etcFile}
                                setMbrFile={setEtcFile}
                                mbrFileNm={etcFileNm}
                                setMbrFileNm={setEtcFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                                width={580}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt10 taC">
                    <span className="fm-c fs12 fc4A90A4">
                        ※ 임시저장은 성명 입력 후 가능하며, 작성완료는 전체 항목 입력 후 가능합니다.
                    </span>
                </div>

                {/* 버튼 */}
                <div className="dpFlx jcC mt25 gap10 mb10">
                    <Button
                        width={100} height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCancelBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="닫기"
                        onClickFunc={() => {
                            setModalOpen(false);
                        }}
                    />

                    {!Util.isEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={100} height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styDeleteBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="삭제"
                            onClickFunc={handleDelete}
                        />
                    )}

                    {atrzSttsCd === "01" && (
                        <Button
                            buttonName="임시저장"
                            width={120} height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styTempBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            onClickFunc={handleTempSave}
                        />
                    )}

                    <Button
                        width={120} height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCompleteBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="작성완료"
                        onClickFunc={handleSave}
                    />
                </div>
            </div>

            <Modal modalOpen={openJoinExample} dim={true} visible={true}
                titleEl={<DialogTitleBar title="첨부파일 업로드 예시" backgroundColor={AppContext.themeColor}/>}
                onCloseFunc={() => setOpenJoinExample(false)}
            >
                <div className="p20 taC">
                    <img
                        src="/assets/img/common/join-example.jpg"
                        alt="가입 신청서"
                        style={{maxWidth: "50vw", maxHeight: "70vh", width: "auto", height: "auto"}}
                    />
                </div>
            </Modal>

        </div>
    );
};

export default MbrasNewMngDialog;
